const mEditionProductDiscountCodesEdit = {
  mEditionProductDiscountCodesEdit: {
    alerts: {
      updateProductoCuponDescuento: {
        error: 'Un error ha ocurrido. Verifica los datos ingresados y vuelve a intentarlo.',
        success: 'El código de descuento fue editado exitosamente.'
      }
    },

    buttonPrimary: 'GUARDAR',

    inputs: {
      codigo: {
        label: 'Nombre de Descuento',
        placeholder: 'DESC123'
      },

      fecha_fin: {
        label: 'Fecha de Finalización',
        message: '* El código podrá ser utilizado hasta esta fecha.',
        placeholder: 'AAAA-MM-DD'
      },

      fecha_inicio: {
        label: 'Fecha de Inicio',
        message: '* El código podrá ser utilizado a partir de esta fecha.',
        placeholder: 'AAAA-MM-DD'
      },

      monto_descuento_final: {
        label: 'Monto del Descuento',
        placeholder: '130.99'
      },

      monto_descuento_porcent: {
        label: 'Porcentaje del Descuento (%)',
        placeholder: '10.99'
      },

      tipo_descuento: {
        label: 'Tipo de Descuento '
      }
    },

    validation: {
      codigo: {
        maxLength: 'La longitud máxima permitida es de 20 caracteres.',
        minLength: 'La longitud mínima permitida es de 4 caracteres.',
        required: 'Nombre de descuento es requerido. De 4 a 20 caracteres.'
      },

      monto_descuento_0: {
        decimal: 'Descuento debe ser número decimal.',
        maxValue: 'El valor máximo permitido es 100',
        minValue: 'El valor mínimo permitido es 0.01',
        required: 'Descuento es requerido.'
      },

      monto_descuento_1: {
        decimal: 'Descuento debe ser número decimal.',
        minValue: 'El valor mínimo permitido es 0.01',
        required: 'Descuento es requerido.'
      }
    }
  }
}

export default mEditionProductDiscountCodesEdit
